<mg-table [collectionComponent]="this" matSort>

  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Naam</th>
    <td mat-cell *matCellDef="let row"> {{ row.name }}</td>
  </ng-container>

  <ng-container matColumnDef="company">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Bedrijf</th>
    <td mat-cell *matCellDef="let row"> {{ row.company?.name }}</td>
  </ng-container>

  <ng-container matColumnDef="school">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> School</th>
    <td mat-cell *matCellDef="let row"> {{ row.school?.name }}</td>
  </ng-container>

  <ng-container matColumnDef="other">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Anders</th>
    <td mat-cell *matCellDef="let row"> {{ row.other }}</td>
  </ng-container>

  <ng-container matColumnDef="meetingPerson">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Ontmoeting met</th>
    <td mat-cell *matCellDef="let row"> {{ row.meetingPerson }}</td>
  </ng-container>

  <ng-container matColumnDef="registerTime">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Aangemeld om</th>
    <td mat-cell *matCellDef="let row"> {{ row.registerTime | date: 'medium' }}</td>
  </ng-container>

  <ng-container matColumnDef="unregisterTime">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Afgemeld om</th>
    <td mat-cell *matCellDef="let row"> {{ row.unregisterTime | date: 'medium' }}</td>
  </ng-container>

</mg-table>

